// src/components/Footer.jsx
import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-info">
          <span>📞 掛號專線：03-4571515</span>
          <span>📍 地址：福州一街77號</span>
        </div>
        <div className="footer-copy">
          © {new Date().getFullYear()} Chii Chung Clinic. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
